export function About() {
  return (
    <section className="bg-white py-20 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="bg-cyan-400 border-4 border-black p-12 shadow-[20px_20px_0px_0px_rgba(0,0,0,1)] relative">
          <div className="absolute -top-4 -left-4 w-12 h-12 bg-orange-600 rotate-45 border-4 border-black" />
          <p className="text-3xl md:text-4xl font-black leading-relaxed text-center">
            Allier créativité graphique et expertise technique. Je vous accompagne de l'idée au déploiement pour mettre en valeur votre activité.
          </p>
          <div className="absolute -bottom-4 -right-4 w-8 h-8 bg-violet-600 rounded-full border-4 border-black" />
        </div>
      </div>
    </section>
  );
}
